import ConfigRestService from './_private/ConfigRestService';
import ServerConfig from '@core/models/country/ServerConfig';
import ConfigMapper from '@core/mappers/country/DirectusConfigMapper';
import IDirectusConfigDto from '@core/mappers/country/dtos/IDirectusConfigDto';
import commonConfig from '@src/config/common';
class Mappers {
    configMapper: ConfigMapper = new ConfigMapper();
}

export class ConfigService {
    private configRestService: ConfigRestService = new ConfigRestService();
    private mappers: Mappers = new Mappers();

    /**
     * @throws {RequestError}
     * @throws {Error}
     */
    public getConfig = async (): Promise<ServerConfig> => {
        const configDto = await this.configRestService.getDirectusConfig();
        const mappedConfigs = this.mappers.configMapper.map(configDto as IDirectusConfigDto, false);
        const { host, hostSocket, socketPath } = commonConfig.services.tickets.payment;
        const allowancesUrl = commonConfig.services.allowancesUrl;
        const virtualTournamentsEndpoint = commonConfig.services.virtualTournamentsEndpoint;
        mappedConfigs.tickets.paymentHost = host;
        mappedConfigs.tickets.allowancesUrl = allowancesUrl;
        mappedConfigs.tickets.virtualTournamentsEndpoint = virtualTournamentsEndpoint;
        mappedConfigs.tickets.paymentHostSocket = hostSocket;
        mappedConfigs.tickets.socketPath = socketPath;
        return mappedConfigs;
    }
}

export default new ConfigService();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/configs/ConfigService.ts